export default __webpack_public_path__ + "static/media/4.93bfe794.png";